import React from 'react';
import './Pagination.scss'

interface PaginationComponentProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (pageNumber: number) => void;
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({ currentPage, totalPages, onPageChange }) => {
    const generatePages = () => {
        const pages: (number | string)[] = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }

        return pages;
    };

    return (
        <div className="tapps-paginacion">
            <button
                className="tapps-paginacion-direction"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <i className="iconwhite-arrow-8-left"></i> Anterior
            </button>

            {generatePages().map((page, idx) =>
                typeof page === 'number' ? (
                    <button
                        key={idx}
                        className={`tapps-paginacion-item ${currentPage === page ? 'active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ) : (
                    <span key={idx} className="tapps-paginacion-dots">...</span>
                )
            )}

            <button
                className="tapps-paginacion-direction"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                Siguiente <i className="iconwhite-arrow-8-right"></i>
            </button>
        </div>
    );

};

export default PaginationComponent;